import React, { useEffect, useState } from 'react'
import { Container } from 'react-bootstrap'
import {
  initialActiveValue,
  initialmovieInputValue,
  intitalBooleanValueChangeDone,
} from '../Data/StaticPersonandMoviedata'
import English from './English'
import EnglishandTeluguFields from './EnglishandteField'
import GetFormattedDate from './getFormateddateforlistmovies'
import sendtoEditdata from './SendDatatoEditFromWiki'
import { castformatdata, castformatdatate } from './wikiCastObjectform'
export default function Wikimovies(props) {
  const {
    editData,
    wikilink,
    sendEditdata,
    modeUrl,
    sendBooleanValueChangeofEdit,
    contentType,
    editMovieData,
    sendmovieData,
  } = props
  const [movieData, setmoviedata] = useState([])
  const [moviePersons, setmoviePersons] = useState()
  const [active, setActive] = useState(initialActiveValue)
  const [BooleanValueChangeDone, setBooleanValueChangeDone] = useState(
    intitalBooleanValueChangeDone,
  )
  const [inputData, setInputData] = useState(initialmovieInputValue)

  const compare = (a, b, type) => {
    const isSameUser = (a, b) => a.name_En === b.name_En

    const onlyInLeft = (left, right, compareFunction) => {
      if (left.length > 0) {
        return left.filter(
          leftValue => !right.some(rightValue => compareFunction(leftValue, rightValue)),
        )
      }

      return left
    }

    const onlyInB = onlyInLeft(b, a, isSameUser)

    const result = [...onlyInB]

    let modifiedobject = []
    if (type === 'cast') {
      modifiedobject = result.map(e => {
        if (e.personID) {
          return {
            newPerson: true,
            PK: e.PK,
            SK: e.SK,
            name_En: e.name_En,
            name_Te: e.name_Te,
            role: e.role ? e.role : '',
            roleName_En: e.roleName_En ? e.roleName_En : '',
            roleName_Te: e.roleName_Te ? e.roleName_Te : '',
            personID: e.personID,
            personUUID: e.personUUID,
          }
        }

        return {
          newPerson: true,
          name_En: e.name_En,
          name_Te: e.name_Te,
          role: `${e.role ? e.role : ''}`,
          roleName_En: e.roleName_En ? e.roleName_En : '',
          roleName_Te: e.roleName_Te ? e.roleName_Te : '',
        }
      })
    } else {
      modifiedobject = result.map(e => {
        const personObject = {
          newPerson: true,
          name_En: e.name_En,
          name_Te: e.name_Te ? e.name_Te : '',
          role: type,
        }
        if (e.personID) {
          personObject.PK = e.PK
          personObject.SK = e.SK
          personObject.personID = e.personID
          personObject.personUUID = e.personUUID
          return personObject
        }

        return personObject
      })
    }

    return modifiedobject
  }

  const objectNotPresent = {
    MoviecastnotPresent: compare(editData.Moviecast, inputData.Moviecast, 'cast'),
    movieDirectornotPresent: compare(editData.Moviedirector, inputData.Moviedirector, 'Director'),
    movieProducernotPresent: compare(editData.MovieProducer, inputData.MovieProducer, 'Producer'),
    movieCinematonotPresent: compare(
      editData.MovieCimematographer,
      inputData.MovieCimematographer,
      'Cinematographer',
    ),
    movieEditornotPresent: compare(editData.MovieEditor, inputData.MovieEditor, 'Editor'),
    movieMusicnotPresent: compare(editData.Moviemusicby, inputData.Moviemusicby, 'Musician'),
    movieWriternotPresent: compare(editData.Moviewritter, inputData.Moviewritter, 'Writer'),
    MovieDialogeWritternotPresent: compare(
      editData.MovieDialoge,
      inputData.MovieDialoge,
      'Dialogue Writer',
    ),
    MovieScreenPlaynotPresent: compare(
      editData.MovieScreenPlay,
      inputData.MovieScreenPlay,
      'Screenplay',
    ),
    MovieStorynotPresent: compare(editData.story, inputData.story, 'Story'),
  }

  const handleActiveChange = (e, field) => {
    sendBooleanValueChangeofEdit('active', true)
    const activeTemp = { ...active }
    const value = active[field]
    if (value === 'FALSE') {
      if (field === 'cast') {
        const editMovieDataTemp = { ...editMovieData }
        editMovieDataTemp.Cast = [...editData.Moviecast, ...objectNotPresent.MoviecastnotPresent]
        sendmovieData(editMovieDataTemp)
      }

      sendtoEditdata(
        { field, editData, inputData, objectNotPresent },
        sendEditdata,
        sendBooleanValueChangeofEdit,
      )
      activeTemp[field] = 'TRUE'
    } else {
      activeTemp[field] = 'FALSE'
    }

    setActive(activeTemp)
  }

  const renderName = (movieDataExists, fieldname) => {
    if (movieDataExists[fieldname]) {
      return movieDataExists[fieldname].map(e => e.name_Te)
    }
  }

  const movieDataInput = movieDataExists => ({
    Bio: movieDataExists.about_En ? movieDataExists.about_En : '',
    biote: movieDataExists.about_Te ? movieDataExists.about_Te : '',
    genRe: movieDataExists.genre ? movieDataExists.genre : [],
    movieName: movieDataExists.title_En ? movieDataExists.title_En : [],
    Moviedirector: movieDataExists.directedBy_En ? movieDataExists.directedBy_En : [],
    Moviedirectorte: renderName(movieDataExists, 'directedBy_En'),
    MovieCimematographer: movieDataExists.cinematography_En
      ? movieDataExists.cinematography_En
      : [],
    MovieCimematographerTelugu: renderName(movieDataExists, 'cinematography_En'),
    Moviemusicby: movieDataExists.musicBy_En ? movieDataExists.musicBy_En : [],
    Moviemusicbyte: renderName(movieDataExists, 'musicBy_En'),

    MovieProducer: movieDataExists.producedBy_En ? movieDataExists.producedBy_En : '',
    MovieProducerTelugu: renderName(movieDataExists, 'producedBy_En'),
    country: movieDataExists.country ? movieDataExists.country : '',
    runTime: movieDataExists.runningTime ? movieDataExists.runningTime : '',
    poster: movieDataExists.posterURL ? movieDataExists.posterURL : '',

    Moviecast: castformatdata(movieDataExists),
    Moviecastte: castformatdatate(movieDataExists),
    MovieEditor: movieDataExists.editedBy_En ? movieDataExists.editedBy_En : [],
    MovieEditorte: renderName(movieDataExists, 'editedBy_En'),
    story: movieDataExists.storyBy_En ? movieDataExists.storyBy_En : [],
    storyte: renderName(movieDataExists, 'storyBy_En'),
    wikilink: wikilink ? wikilink : '',
    MovieProductionCompany: ProductionCompney(movieDataExists, 'productioncompany_En'),
    MovieProductionCompanyTelugu: renderName(movieDataExists, 'productioncompany_En'),
    MovieDistibutor: MovieDistributor(movieDataExists),
    MovieDistibutorTelugu: renderName(movieDataExists, 'distributedBy_En'),
    collection: movieDataExists.boxOffice ? movieDataExists.boxOffice : '',
    Budget: movieDataExists.budget ? movieDataExists.budget : '',
    releaseDate: GetFormattedDate(
      parseInt(movieDataExists.movieReleasedDate ? movieDataExists.movieReleasedDate : '', 10),
    ),
    MovieDialoge: MovieDialogeWritter(movieDataExists),
    MovieDialogete: renderName(movieDataExists, 'dialogueBy_En'),
    imdb: movieDataExists.movieRating ? movieDataExists.movieRating : '',
    language: movieDataExists.language
      ? movieDataExists.language.split().map(e => ({
          label: e,
          value: e,
        }))
      : '',
    Moviewritter: MovieWritter(movieDataExists),
    Moviewritterte: renderName(movieDataExists, 'writtenBy_En'),
    contentType,
  })
  const MovieDistributor = movieDataExists => {
    if (movieDataExists.distributedBy_En) {
      return movieDataExists.distributedBy_En.map(e => e.name_En)
    }

    return []
  }

  const MovieDialogeWritter = movieDataExists => {
    if (movieDataExists.dialogueBy_En) {
      return movieDataExists.dialogueBy_En
    }

    return []
  }

  const ProductionCompney = movieDataExists => {
    if (movieDataExists.productioncompany_En) {
      return movieDataExists.productioncompany_En.map(e => e.name_En)
    }

    return ''
  }

  const MovieWritter = movieDataExists => {
    if (movieDataExists.writtenBy_En) {
      return movieDataExists.writtenBy_En
    }

    return ''
  }

  const updateMultipleInputData = input => {
    const data = { ...inputData }
    Object.keys(input).map(keyname => {
      data[keyname] = input[keyname]
      return data[keyname]
    })
    setInputData(data)
  }

  const sendinputdata = data => {
    setInputData(data)
  }

  const updateInputData = (fieldname, fieldvalue) => {
    const data = { ...inputData }
    data[fieldname] = fieldvalue
    setInputData(data)
  }

  const sendBooleanValueChangeDone = (field, data) => {
    const BooleanValueforValueChangeTemp = { ...BooleanValueChangeDone }
    BooleanValueforValueChangeTemp[field] = data
    setBooleanValueChangeDone(BooleanValueforValueChangeTemp)
  }

  useEffect(() => {
    const getMovieData = async () => {
      const movieDataFromWiki = props.dataFromWiki
      let movieData = initialmovieInputValue
      if (movieDataFromWiki) {
        movieData = movieDataFromWiki.movieData[0]
        const moviePersons = movieDataFromWiki.movieAndPersons
        setmoviedata(movieData)
        setmoviePersons(moviePersons)
      }

      const movieDataExists = movieData && movieData
      const moviedatahere = movieDataInput(movieDataExists)

      updateMultipleInputData(moviedatahere)
    }

    getMovieData()
  }, [])
  return (
    <div style={{ width: '520px' }}>
      {modeUrl ? <></> : <div style={{ height: '50px' }}></div>}
      <div
        className='movie1'
        style={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'inherit',
          position: 'relative',
        }}
      ></div>
      <div className='movie p-3'>
        <div className='createmovie'>{modeUrl ? 'Wiki' : ''}</div>
        <form style={{ width: '100%' }}>
          <Container>
            <EnglishandTeluguFields
              editData={editData ? editData : {}}
              modeUrl={modeUrl}
              active={active}
              movieMode={'edit'}
              handleActiveChange={handleActiveChange}
              movieData={movieData}
              inputData={inputData}
              moviePersons={moviePersons}
              BooleanValueChangeDone={BooleanValueChangeDone}
              sendBooleanValueChangeDone={sendBooleanValueChangeDone}
              updateInputData={updateInputData}
              sendinputdata={sendinputdata}
            />
            <English
              editData={editData ? editData : {}}
              modeUrl={modeUrl}
              active={active}
              handleActiveChange={handleActiveChange}
              movieData={movieData}
              inputData={inputData}
              BooleanValueChangeDone={BooleanValueChangeDone}
              sendBooleanValueChangeDone={sendBooleanValueChangeDone}
              updateInputData={updateInputData}
              sendinputdata={sendinputdata}
            />
          </Container>
        </form>
      </div>
      {/* <button onClick={()=>SendtoEdit()}>send selected to edit</button> */}
    </div>
  )
}
